import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface Coupon {
  id: number;
  code: string;
  type: 'fixed' | 'percent' | 'free_shipping';
  value: number;
  min_order_value?: number | null;
  quantity?: number | null;
  used_count: number;
  init_at?: string | null;
  finish_at?: string | null;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export const couponService = {
  getAll: (params?: any) => api.get(API_ENDPOINTS.COUPONS.INDEX, { params }),
  getById: (id: number) => api.get(API_ENDPOINTS.COUPONS.SHOW(id)),
  create: (data: Partial<Coupon>) => api.post(API_ENDPOINTS.COUPONS.STORE, data),
  update: (id: number, data: Partial<Coupon>) => api.put(API_ENDPOINTS.COUPONS.UPDATE(id), data),
  delete: (id: number) => api.delete(API_ENDPOINTS.COUPONS.DELETE(id)),
};
